import api from '../api/mobileSecuritySettingsApi';
import { OperationResult } from '../types/apiTypes';
import { AgeVerificationConfiguration,
    MobileSecuritySettings,
    SaveAgeVerificationConfigurationRequest,
    SaveMobileSecuritySettingsRequest } from '../types/mobileSecuritySettingsTypes';

export class MobileSecurityApiError extends Error {
    statusCode: number;

    constructor(message: string, statusCode: number) {
        super(message);
        this.statusCode = statusCode;
    }
}

function unwrapOperationResult<T>(result: OperationResult<T>): T {
    if (!result.isSuccess) {
        throw new MobileSecurityApiError(
            result.error?.message ?? 'Request failed.',
            result.error?.statusCode ?? 500,
        );
    }

    return result.data;
}

export async function getMobileSecuritySettings(orgId: string): Promise<MobileSecuritySettings> {
    const result = await api.get(orgId);
    return unwrapOperationResult(result);
}

export async function saveMobileSecuritySettings(data: SaveMobileSecuritySettingsRequest): Promise<MobileSecuritySettings> {
    const result = await api.save(data);
    return unwrapOperationResult(result);
}

export async function getAgeVerificationConfiguration(orgId: string): Promise<AgeVerificationConfiguration> {
    const result = await api.getAgeVerification(orgId);
    return unwrapOperationResult(result);
}

export async function saveAgeVerificationConfiguration(
    data: SaveAgeVerificationConfigurationRequest,
): Promise<AgeVerificationConfiguration> {
    const result = await api.saveAgeVerification(data);
    return unwrapOperationResult(result);
}
